// https://developers.google.com/tag-manager/enhanced-ecommerce#checkout
export const sendCheckoutStepToDataLayer = (checkoutStep, products, location, option) => {
    if (window && window.dataLayer) {
        try {
            var eventName = '';
            var optionName;
            
            switch (checkoutStep) {
                case checkoutSteps.pageLoad:
                    eventName = 'begin_checkout';
                    break;
                case checkoutSteps.selectShippingMethod:
                    return; // WTB 09-11-24 Don't send event for add_shipping_info
                case checkoutSteps.confirmPaymentMethod:
                    eventName = 'add_payment_info';
                    optionName = 'payment_type';
                    break;
                default:
                    break;
            }
            const currencyCode = products[0].currencyCode || products[0].CurrencyCode;
            
            var dataLayerObj = {
                'event': eventName,
                'ecommerce': {
                    'currency': currencyCode,
                    'value': products.reduce((acc, product) => acc + ((product.price || product.Price) * (product.quantity || product.Quantity)), 0),
                    'items': products.map((product) => {
                            const p =
                                {
                                    'item_name': product.name || product.Name,
                                    'item_id': product.id || product.Id,
                                    'price': product.price || product.Price,
                                    'item_brand': product.brand || product.Brand,
                                    'item_category': product.category || product.Category,
                                    'item_variant': product.variant || product.Variant,
                                }
                            const quantity = product.quantity || product.Quantity;
                            if(quantity)
                                p.quantity = quantity;
                            return p;
                        }
                    )
                }
            };
            
            // Add option to dataLayer object for shipping tier or payment type.
            if (optionName && option) {
                dataLayerObj.ecommerce[optionName] = option;
            }
            
            // Add coupon if it exists from couponActionCreators.
            if (window.couponCode) {
                dataLayerObj.ecommerce['coupon'] = window.couponCode;
            }

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(dataLayerObj);
        } catch (e) {
            console.log("Error pushing to gtm", e)
        }
    }
}

export const checkoutSteps = {
    pageLoad: 1,
    selectShippingMethod: 2,
    confirmPaymentMethod: 3
}

export const sendWishListToDataLayer = (product, quantity) => {
    if (window && window.dataLayer) {
        try {
            const currencyCode = product.currencyCode || product.CurrencyCode;
            const price = product.price || product.Price;
            const gtmQuantity = quantity || product.Quantity || product.quantity;
            const value = price > 0 ? price * parseInt(quantity) : 0;

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                'event': 'add_to_wishlist',
                'ecommerce': {
                    'currency': currencyCode,
                    'value' : value,
                    'items': [{
                        'item_id': product.id || product.Id,
                        'item_name': product.name || product.Name,
                        'item_brand': product.brand || product.Brand,
                        'item_category': product.category || product.Category,
                        'item_variant': product.variant || product.Variant,
                        'price': price,
                        'quantity': gtmQuantity,
                    }]
                }
            });
        } catch (e) {
            console.log("Error pushing Wishlist item to Data Layer", e)
        }
    }
}

export const pushGtmData = (linkGTMCategory, linkGTMAction, linkGTMLabel) => {
    let values = [];

    if (!!linkGTMCategory) {
        values.push('"category": "' + linkGTMCategory + '"');
    }
    if (!!linkGTMAction) {
        values.push('"action": "' + linkGTMAction + '"');
    }
    if (!!linkGTMLabel) {
        values.push('"label": "' + linkGTMLabel + '"');
    }
    if (!!values.Count) {
        window.dataLayer.push(JSON.parse("{" + values.join(", ") + "}"));
    }
}

export const sendFilterDataToDataLayer = (Category, Term) => {
    if (window && window.dataLayer) {
        try {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
                'filterCategory': Category,
                'filterTerm': Term,
                'event': "filterUsed"
            });

        } catch (e) {
            console.log("Error pushing Filters item to Data Layer", e)
        }
    }
}

export const sendSortingToDataLayer = (SortByType) => {
    if (window && window.dataLayer) {
        try {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
            'sortBy': SortByType, // expected values include Most Popular, Most Relevant, Most Recent etc
            'event': "sortBy"
            });


        } catch (e) {
            console.log("Error pushing Filters item to Data Layer", e)
        }
    }
}

export const sendCustomerServiceClickToDataLayer = (contactAvailbilityType) => {
    if (window && window.dataLayer) {
        try {
            window.dataLayer.push({
                'event': 'customerServiceContact',
                'contact_availbility_type': contactAvailbilityType,
                });
        } catch (e) {
            console.log("Error pushing Customer Service Contact click event to Data Layer", e)
        }
    }
}
